import postFetcher from 'api/utils/postFetcher';
import { useCallback } from 'react';
import type { AuthLoginTotpReturn } from 'types/legacyDashboard';

const useLoginTotpCall = () => {
  const url = `${process.env.VITE_API_ROOT}/auth/totp/authenticate`;

  const callback = useCallback(
    async (email: string, methodId: string, totpCode: string, rememberMe = false) => {
      if (!email || !methodId) {
        return undefined;
      }

      const result: AuthLoginTotpReturn | undefined = await postFetcher({
        url,
        body: { email, methodId, totpCode, rememberme: rememberMe },
      });

      return result;
    },
    [url]
  );

  return callback;
};

export default useLoginTotpCall;
